<template>
    <section class="form-group">
        <template v-if="label">
            <h4 class="form-group__label">
                {{ label }}
            </h4>
        </template>
        <slot></slot>
    </section>
</template>

<script>
    export default {
        props: {
            label: { type: String, default: null },
        },
    }
</script>
